import Link from 'next/link';
import React, { FC, MouseEventHandler } from 'react';
import Ripples from 'react-ripples';
import IcomoonIcon from '../icomoon-icon/icomoon-icon';
import getTailwindConfig from '../../../helpers/get-tailwind-config';

interface Props {
  readonly label: string;
  readonly onClick?: MouseEventHandler;
  readonly url: string;
}

const ProductDownloadButton: FC<Props> = ({ label, onClick, url }: Props) => {
  const fullConfig = getTailwindConfig();
  const frenchBlue = fullConfig.theme.colors['french-blue'];

  return (
    <Ripples
      className="rounded-lg"
      color={`rgba(${frenchBlue.rgb}, .2)`}
      during={1200}
    >
      <Link href={url} passHref>
        <a
          className="bg-light-blue hover:bg-light-blue-dark flex items-center justify-between focus:outline-none px-6 py-4 rounded-lg w-full"
          href={url}
          onClick={onClick}
          rel="noreferrer"
          target="_blank"
        >
          <div className="flex items-center">
            <IcomoonIcon color="french-blue" name="file" size="xl" />

            <span className="ml-3">{label}</span>
          </div>

          <div className="flex items-center">
            <IcomoonIcon
              className="-mb-2px"
              color="french-blue"
              name="download"
              size="sm"
            />

            <span className="font-bold ml-2 text-french-blue text-sm">
              Download
            </span>
          </div>
        </a>
      </Link>
    </Ripples>
  );
};

ProductDownloadButton.defaultProps = {
  onClick: () => ({}),
};

export default ProductDownloadButton;
